import LatestNewsCard from './LatestNewsCard'

// importing helper components
import HeadingPart from '../../Helper/HeadingPart'
import MoreArrow from '../../Helper/MoreArrow'

// importing constants
import moreArrow from '../../../constants/moreArrow'
import headingPart from '../../../constants/headingPart'
import home from '../../../constants/home'

// importing images
import latestNews1 from '../../../assets/images/Home/LatestNews/latestNews1.png'
import latestNews2 from '../../../assets/images/Home/LatestNews/latestNews2.png'
import latestNews3 from '../../../assets/images/Home/LatestNews/latestNews3.png'

const index = () => {
  return (
    <div className="w-full">
        <div className="flex items-center md:justify-between">
            <HeadingPart heading={headingPart.HEADING_LATEST_NEWS} text={headingPart.TEXT_LATEST_NEWS} order_1={1} />
            <span className="hidden md:flex mr-8"><MoreArrow text={moreArrow.TEXT_MORE_NEWS} /></span>
        </div>
        <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 mt-5">
            <LatestNewsCard imgScr={latestNews1} author={home.LATEST_NEWS_AUTHOR} date={home.LATEST_NEWS_DATE} heading={home.LATEST_NEWS_HEADING1} text={home.LATEST_NEWS_TEXT1} />
            <LatestNewsCard imgScr={latestNews2} author={home.LATEST_NEWS_AUTHOR} date={home.LATEST_NEWS_DATE} heading={home.LATEST_NEWS_HEADING2} text={home.LATEST_NEWS_TEXT2} />
            <LatestNewsCard imgScr={latestNews3} author={home.LATEST_NEWS_AUTHOR} date={home.LATEST_NEWS_DATE} heading={home.LATEST_NEWS_HEADING3} text={home.LATEST_NEWS_TEXT3} />
        </div>
    </div>
  )
}

export default index